<template>
  <div v-if="isShowPlaceHolder" class="skeleton-light-grey-200 gem-ai-banner-placeholder"></div>
  <div v-else class="gem-ai-banner">
    <div>
      <div class="logo">
        <span>{{ $t('gemAIBanner.powered_by') }}</span>
        <svg width="47" height="18" viewBox="0 0 47 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.7484 7.05966C6.67738 6.82955 6.57937 6.62358 6.45437 6.44176C6.33221 6.2571 6.18448 6.09943 6.01119 5.96875C5.84073 5.83807 5.64471 5.74006 5.42312 5.67472C5.20153 5.60653 4.96005 5.57244 4.69869 5.57244C4.22994 5.57244 3.81232 5.69034 3.44585 5.92614C3.07937 6.16193 2.79102 6.50852 2.58079 6.96591C2.3734 7.42045 2.26971 7.97443 2.26971 8.62784C2.26971 9.28693 2.3734 9.84517 2.58079 10.3026C2.78817 10.7599 3.07653 11.108 3.44585 11.3466C3.81516 11.5824 4.24414 11.7003 4.73278 11.7003C5.17596 11.7003 5.55948 11.6151 5.88335 11.4446C6.21005 11.2741 6.46147 11.0327 6.63761 10.7202C6.81374 10.4048 6.90181 10.0355 6.90181 9.61222L7.25977 9.66761H4.89045V8.43182H8.43164V9.48011C8.43164 10.2273 8.27255 10.8736 7.95437 11.419C7.63619 11.9645 7.19869 12.3849 6.64187 12.6804C6.08505 12.973 5.44585 13.1193 4.72425 13.1193C3.92028 13.1193 3.21431 12.9389 2.60636 12.5781C2.00124 12.2145 1.52823 11.6989 1.18732 11.0312C0.849254 10.3608 0.68022 9.56534 0.68022 8.64489C0.68022 7.94034 0.779652 7.31108 0.978516 6.7571C1.18022 6.20312 1.46147 5.73295 1.82227 5.34659C2.18306 4.95739 2.60636 4.66193 3.09215 4.46023C3.57795 4.25568 4.10636 4.15341 4.67738 4.15341C5.16033 4.15341 5.61062 4.22443 6.02823 4.36648C6.44585 4.50568 6.81658 4.70455 7.14045 4.96307C7.46715 5.22159 7.73562 5.52841 7.94585 5.88352C8.15607 6.23864 8.29386 6.63068 8.3592 7.05966H6.7484ZM12.79 13.1278C12.1337 13.1278 11.5669 12.9915 11.0897 12.7188C10.6152 12.4432 10.2502 12.054 9.9945 11.5511C9.73881 11.0455 9.61097 10.4503 9.61097 9.76562C9.61097 9.09233 9.73881 8.50142 9.9945 7.9929C10.253 7.48153 10.6138 7.08381 11.0769 6.79972C11.54 6.51278 12.084 6.36932 12.709 6.36932C13.1124 6.36932 13.4931 6.43466 13.851 6.56534C14.2118 6.69318 14.53 6.89205 14.8056 7.16193C15.084 7.43182 15.3027 7.77557 15.4618 8.19318C15.6209 8.60795 15.7005 9.10227 15.7005 9.67614V10.1491H10.3354V9.10938H14.2218C14.2189 8.81392 14.155 8.55114 14.03 8.32102C13.905 8.08807 13.7303 7.90483 13.5059 7.77131C13.2843 7.63778 13.0257 7.57102 12.7303 7.57102C12.415 7.57102 12.138 7.64773 11.8993 7.80114C11.6607 7.9517 11.4746 8.15057 11.3411 8.39773C11.2104 8.64205 11.1436 8.91051 11.1408 9.20312V10.1108C11.1408 10.4915 11.2104 10.8182 11.3496 11.0909C11.4888 11.3608 11.6834 11.5682 11.9334 11.7131C12.1834 11.8551 12.476 11.9261 12.8113 11.9261C13.0357 11.9261 13.2388 11.8949 13.4206 11.8324C13.6025 11.767 13.7601 11.6719 13.8936 11.5469C14.0272 11.4219 14.128 11.267 14.1962 11.0824L15.6365 11.2443C15.5456 11.625 15.3723 11.9574 15.1167 12.2415C14.8638 12.5227 14.54 12.7415 14.1451 12.8977C13.7502 13.0511 13.2985 13.1278 12.79 13.1278ZM17.0055 13V6.45455H18.4799V7.56676H18.5566C18.693 7.19176 18.9189 6.89915 19.2342 6.68892C19.5495 6.47585 19.926 6.36932 20.3635 6.36932C20.8066 6.36932 21.1802 6.47727 21.4842 6.69318C21.791 6.90625 22.0069 7.19744 22.1319 7.56676H22.2001C22.345 7.20312 22.5893 6.91335 22.9331 6.69744C23.2797 6.47869 23.6902 6.36932 24.1646 6.36932C24.7669 6.36932 25.2583 6.55966 25.639 6.94034C26.0197 7.32102 26.2101 7.87642 26.2101 8.60653V13H24.6632V8.84517C24.6632 8.43892 24.5552 8.14205 24.3393 7.95455C24.1234 7.7642 23.8592 7.66903 23.5467 7.66903C23.1745 7.66903 22.8833 7.78551 22.6731 8.01847C22.4657 8.24858 22.362 8.5483 22.362 8.91761V13H20.8493V8.78125C20.8493 8.44318 20.747 8.1733 20.5424 7.97159C20.3407 7.76989 20.0765 7.66903 19.7498 7.66903C19.5282 7.66903 19.3265 7.72585 19.1447 7.83949C18.9629 7.95028 18.818 8.10795 18.71 8.3125C18.6021 8.5142 18.5481 8.75 18.5481 9.01989V13H17.0055ZM28.964 13H27.2765L30.3489 4.27273H32.3006L35.3773 13H33.6898L31.3588 6.0625H31.2907L28.964 13ZM29.0194 9.57812H33.6216V10.848H29.0194V9.57812ZM38.1078 4.27273V13H36.5268V4.27273H38.1078Z" fill="url(#paint0_linear_3075_75523)" />
          <path d="M42.7612 1.0282C42.8335 0.792683 43.1669 0.792683 43.2392 1.0282L43.7184 2.58942C43.8115 2.89264 44.0429 3.13372 44.3421 3.23913L45.8311 3.76382C46.0536 3.84224 46.0536 4.15698 45.8311 4.2354L44.3421 4.76008C44.0429 4.86549 43.8115 5.10658 43.7184 5.4098L43.2392 6.97101C43.1669 7.20653 42.8335 7.20653 42.7612 6.97101L42.282 5.4098C42.1889 5.10658 41.9575 4.86549 41.6584 4.76008L40.1694 4.2354C39.9468 4.15698 39.9468 3.84224 40.1694 3.76382L41.6584 3.23913C41.9575 3.13372 42.1889 2.89264 42.282 2.58942L42.7612 1.0282Z" fill="url(#paint1_linear_3075_75523)" />
          <defs>
            <linearGradient id="paint0_linear_3075_75523" x1="47" y1="-1.14082e-05" x2="9.35735" y2="-11.3662" gradientUnits="userSpaceOnUse">
              <stop stop-color="#D8E1FF" />
              <stop offset="1" stop-color="#C8ACFF" />
            </linearGradient>
            <linearGradient id="paint1_linear_3075_75523" x1="47.2278" y1="0.851559" x2="41.0226" y2="0.0280776" gradientUnits="userSpaceOnUse">
              <stop stop-color="#D8E1FF" />
              <stop offset="1" stop-color="#C8ACFF" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <span class="title">
        {{ $t('gemAIBanner.from_reference') }} <br />  {{ $t('gemAIBanner.to_editable_layout') }}
      </span>
      <div @click="onCreateLandingPage" class="button-try-it">
        {{ $t('gemAIBanner.try_beta_now') }}
      </div>

      <a :href="learnMoreLink" target="_blank" class="learning-more">
        <span>{{ $t('gemAIBanner.learn_more') }}</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.5 4C4.22386 4 4 4.22386 4 4.5V11.502C4 11.7781 4.22386 12.002 4.5 12.002H11.5C11.7761 12.002 12 11.7781 12 11.502V9.38589C12 9.10975 12.2239 8.88589 12.5 8.88589C12.7761 8.88589 13 9.10975 13 9.38589V11.502C13 12.3304 12.3284 13.002 11.5 13.002H4.5C3.67157 13.002 3 12.3304 3 11.502V4.5C3 3.67157 3.67157 3 4.5 3H6.61539C6.89153 3 7.11539 3.22386 7.11539 3.5C7.11539 3.77614 6.89153 4 6.61539 4H4.5Z" fill="#AAAAAA" />
          <path d="M12 4.70711V7.00024C12 7.27639 12.2239 7.50024 12.5 7.50024C12.7761 7.50024 13 7.27639 13 7.00024V3.50024C13 3.2241 12.7761 3.00024 12.5 3.00024H9C8.72386 3.00024 8.5 3.2241 8.5 3.50024C8.5 3.77639 8.72386 4.00024 9 4.00024H11.2926L6.01597 9.27692C5.82071 9.47218 5.82071 9.78876 6.01597 9.98403C6.21124 10.1793 6.52782 10.1793 6.72308 9.98403L12 4.70711Z" fill="#AAAAAA" />
        </svg>
      </a>
    </div>
    <div class="animation-load">
      <LottieAnimation :width="370" :height="200" style="margin: 0px" :path="'static/animation/ref_to_layout.json'" />
    </div>
  </div>
</template>

<script>
import { createThemeAndPageV7 } from "@/modules/Instant/utils";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import { mapMutations} from "vuex";
import { mutations } from "@/store/page/types";

export default {
  name: "GemAIBanner",
  components: {
    LottieAnimation
  },
  props: {
    isShowPlaceHolder: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      learnMoreLink: process.env.VUE_APP_GEM_AI_LEAR_MORE_LINK
    };
  },

  methods: {
    ...mapMutations("page", {
      setFrameLoading: mutations.SET_FRAME_LOADING
    }),
    
    onCreateLandingPage() {
      try {
        this.setFrameLoading({ isLoading: true, typeLoading: "create_new_page" });
        createThemeAndPageV7("subpages");
      } catch {
        this.setFrameLoading({ isLoading: false, typeLoading: "create_new_page" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.gem-ai-banner-placeholder {
  width: 100%;
  border-radius: 3px;
  height: 220px;
}
.gem-ai-banner {
  width: 100%;
  background-image: url("~@/core/assets/banner/gem-ai-background.png");
  border-radius: 3px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px 16px 0px 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .logo {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    span {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      text-align: center;
      color: #d6d6d6;
      margin-right: 3px;
    }
  }
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    width: 203px;
    color: #ffffff;
  }

  .button-try-it {
    display: flex;
    cursor: pointer;
    margin-top: 8px;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 40px;
    border-radius: 3px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
    position: relative;
    background: linear-gradient(270.07deg, #874CFD 0.03%, #3C38E1 99.92%);
    z-index: 1;
  }

  .button-try-it::before {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 3px;
    background-image: linear-gradient(270.07deg, #3633cc 0.03%, #6d3dcc 99.92%);
    z-index: -1;
    transition: opacity 0.3s ease-out;
    opacity: 0;
  }
  .button-try-it:hover::before {
    opacity: 1;
  }

  .learning-more {
    display: flex;
    align-items: center;
    margin-top: 22px;
    cursor: pointer;
    margin-bottom: 16px;
    opacity: 0.6;
    span {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      text-align: center;
      color: #ffffff;
    }
  }
  .animation-load {
    height: 100%;
    display: flex;
    align-items: flex-end;
  }
}
</style>
